"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.isValidNumber = void 0;
const phone_constants_1 = require("./phone.constants");
const isValidNumber = (number) => {
    const unformattedNumber = number.replace(/\D/g, '');
    return phone_constants_1.CONSTANTS.REGEX.test(unformattedNumber);
};
exports.isValidNumber = isValidNumber;
exports.Utils = {
    isValidNumber: exports.isValidNumber,
};
//# sourceMappingURL=phone.utils.js.map